import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface AuthAuditFilters {
  eventType?: string;
  userRole?: string;
  userEmail?: string;
  userId?: string;
  ipAddress?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

export const useGetAuthAuditLogs = (
  filters: AuthAuditFilters = {},
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.AUTH_AUDIT_LOGS, filters],
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000,
    }
  );
};
